import { __rest, __assign } from 'tslib';
import React, { useRef, useEffect } from 'react';
import { usePopper } from 'react-popper';
import { Portal } from '../Portal/Portal.esm.js';

var defaultProps = {
    placement: "bottom",
    strategy: "fixed"
};
/**
 * @deprecated This component can cause test warnings. Use usePopper instead.
 */
function Popper(_a) {
    var anchorEl = _a.anchorEl, children = _a.children, placement = _a.placement, strategy = _a.strategy, updatePlacement = _a.updatePlacement, passThrough = __rest(_a, ["anchorEl", "children", "placement", "strategy", "updatePlacement"]);
    var popperRef = useRef(null);
    var _b = usePopper(anchorEl, popperRef.current, {
        placement: placement,
        strategy: strategy
    }), forceUpdate = _b.forceUpdate, styles = _b.styles;
    useEffect(function () {
        var timeout = setTimeout(function () {
            forceUpdate === null || forceUpdate === void 0 ? void 0 : forceUpdate();
        }, 5);
        return function () {
            clearTimeout(timeout);
        };
    }, [updatePlacement]);
    return (React.createElement(Portal, null,
        React.createElement("div", __assign({ ref: popperRef }, passThrough, { style: styles.popper }), children)));
}
Popper.defaultProps = defaultProps;

export { Popper };
//# sourceMappingURL=Popper.esm.js.map
